import { Button, Paper, Stack, Typography } from '@mui/material';
import WarningAmberRoundedIcon from '@mui/icons-material/WarningAmberRounded';

type DashboardErrorProps = {
  text?: string;
  error?: Error;
  resetErrorBoundary?: () => void;
};

const DashboardError = ({
  text = 'An unknown error occurred while trying to perform this search.',
  error,
  resetErrorBoundary,
}: DashboardErrorProps) => {
  return (
    <Paper
      data-testid="dashboard-error"
      elevation={3}
      sx={(theme) => {
        const isLightTheme = theme.palette.mode === 'light';

        return {
          p: 3,
          display: 'flex',
          flex: 1,
          justifyContent: 'center',
          alignItems: 'center',
          color: isLightTheme ? theme.blox.colors.medgray : theme.blox.colors.lightgray,
          backgroundColor: isLightTheme
            ? theme.blox.colors.lightgray
            : theme.blox.colors.darkgray,
        };
      }}
    >
      <Stack
        spacing={2}
        sx={{
          alignItems: 'center',
        }}
      >
        <Stack
          direction="row"
          spacing={1}
          sx={{
            alignItems: 'center',
          }}
        >
          <WarningAmberRoundedIcon
            fontSize="small"
            sx={{ mr: 1 }}
          />
          <Typography>{error?.message || text}</Typography>
        </Stack>
        {resetErrorBoundary && (
          <Button
            variant="outlined"
            size="small"
            onClick={resetErrorBoundary}
          >
            Try Again
          </Button>
        )}
      </Stack>
    </Paper>
  );
};

export default DashboardError;
